// AddSequence — modal-embedded form for creating a Process (Sequence) row.
// Refactored 2026-05-05 (Phase 3.2, Class P) onto ModalFormHeader.

import React, { useEffect, useState } from "react";
import CTextField from "../CTextField/CTextField";
import {
  Button, Select, MenuItem, FormControl, Stack, Box,
} from "@mui/material";
import { AccountTreeOutlined } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { validateInput } from "../../utils/validateInput";
import { showErrorToast, showSuccessToast } from "../../utils/Toast";
import ApiCall from "../../utils/apicall";
import { createSequence } from "../../feature/sequenceSlice";
import { ModalFormHeader, FieldLabel } from "../PaperForm";

const AddSequence = (props) => {
  const dispatch = useDispatch();
  const [SequenceName, setSequenceName] = useState("");
  const [jobid, setJobid] = useState("");
  const [job, setjob] = useState([]);

  useEffect(() => {
    const getjob = async () => {
      const res = await ApiCall.get("/job");
      setjob(res.data.data.jobs);
    };
    getjob();
  }, []);

  const handleSubmit = () => {
    if (!jobid) { showErrorToast("Please select a job"); return; }
    if (!validateInput("sequenceName", SequenceName)) { return; }
    const sequenceData = {
      sequence_name: SequenceName,
      job_id: jobid,
    };
    dispatch(createSequence(sequenceData)).then((res) => {
      if (res.type === "createSequence/Sequence/fulfilled") {
        const { message } = res.payload;
        showSuccessToast(message);
        props.setOpen(false);
      }
      if (res.type === "createSequence/Sequence/rejected") {
        showErrorToast("Process not created! Something went wrong.");
      }
    });
  };

  const handleJobSelection = (event) => { setJobid(event.target.value); };

  return (
    <Box>
      <ModalFormHeader
        overline="SFM · Process"
        title="Add Process"
        icon={AccountTreeOutlined}
      />
      <Stack spacing={2}>
        <CTextField
          margin="0px"
          onChange={(event) => setSequenceName(event.target.value)}
          name="sequence_name"
          label="Process name"
          required
        />
        <Box>
          <FieldLabel required>Job</FieldLabel>
          <FormControl fullWidth size="small">
            <Select
              value={jobid}
              onChange={handleJobSelection}
              displayEmpty
              variant="outlined"
              sx={{ textAlign: "left" }}
            >
              <MenuItem value=""><em>Select a job…</em></MenuItem>
              {job.map((dataItem) => (
                <MenuItem key={dataItem.id} value={dataItem.id}>{dataItem.name}</MenuItem>
              ))}
            </Select>
          </FormControl>
        </Box>
        <Button
          disabled={props.isLoading}
          onClick={handleSubmit}
          variant="contained"
          sx={{
            width: "100%",
            mt: 1,
            borderRadius: 2,
            textTransform: "none",
            fontWeight: 600,
            letterSpacing: "0.01em",
          }}
        >
          {props.isLoading ? "Loading…" : "Create Process"}
        </Button>
      </Stack>
    </Box>
  );
};

export default AddSequence;
